import apiHandler from "../core/apiHandler";

/**
 * API para gestión de planes del sistema
 *
 * Endpoints:
 * GET  /api/system/plans
 * PUT  /api/system/plans/{planCode}
 */
const systemPlanApi = apiHandler("system/plans");

export default systemPlanApi;